
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1dy9s_66",
  "button": "awsui_button_vjswe_1dy9s_70",
  "variant-normal": "awsui_variant-normal_vjswe_1dy9s_132",
  "disabled": "awsui_disabled_vjswe_1dy9s_150",
  "variant-primary": "awsui_variant-primary_vjswe_1dy9s_157",
  "variant-link": "awsui_variant-link_vjswe_1dy9s_182",
  "variant-icon": "awsui_variant-icon_vjswe_1dy9s_207",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_1dy9s_232",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1dy9s_259",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1dy9s_284",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1dy9s_309",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1dy9s_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1dy9s_363",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1dy9s_388",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1dy9s_418",
  "button-no-text": "awsui_button-no-text_vjswe_1dy9s_516",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1dy9s_520",
  "full-width": "awsui_full-width_vjswe_1dy9s_523",
  "button-compact": "awsui_button-compact_vjswe_1dy9s_540",
  "icon-left": "awsui_icon-left_vjswe_1dy9s_563",
  "icon-right": "awsui_icon-right_vjswe_1dy9s_568",
  "icon": "awsui_icon_vjswe_1dy9s_563",
  "link": "awsui_link_vjswe_1dy9s_587",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1dy9s_587"
};
  